export default __webpack_public_path__ + "static/media/funny, edgy.1084ae2b.jpg";